import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please add VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY to your .env file.')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
})

export type Database = {
  public: {
    Tables: {
      user_profiles: {
        Row: {
          id: string
          user_id: string
          email: string
          full_name: string | null
          avatar_url: string | null
          preferred_export_platform: string | null
          default_context: any | null
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          user_id: string
          email: string
          full_name?: string | null
          avatar_url?: string | null
          preferred_export_platform?: string | null
          default_context?: any | null
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          user_id?: string
          email?: string
          full_name?: string | null
          avatar_url?: string | null
          preferred_export_platform?: string | null
          default_context?: any | null
          created_at?: string
          updated_at?: string
        }
      }
      user_batches: {
        Row: {
          id: string
          user_id: string
          local_batch_id: string
          name: string
          created_at: string
          updated_at: string
          context: any | null
          image_count: number
          total_size: number | null
          sync_status: 'synced' | 'pending' | 'conflict'
          last_synced_at: string | null
        }
        Insert: {
          id?: string
          user_id: string
          local_batch_id: string
          name: string
          created_at?: string
          updated_at?: string
          context?: any | null
          image_count?: number
          total_size?: number | null
          sync_status?: 'synced' | 'pending' | 'conflict'
          last_synced_at?: string | null
        }
        Update: {
          id?: string
          user_id?: string
          local_batch_id?: string
          name?: string
          created_at?: string
          updated_at?: string
          context?: any | null
          image_count?: number
          total_size?: number | null
          sync_status?: 'synced' | 'pending' | 'conflict'
          last_synced_at?: string | null
        }
      }
      batch_metadata: {
        Row: {
          id: string
          user_id: string
          batch_id: string
          local_image_id: string
          ai_title: string | null
          ai_description: string | null
          ai_keywords: string[] | null
          ai_category: string | null
          ai_emotions: string[] | null
          ai_colors: string[] | null
          ai_objects: string[] | null
          custom_metadata: any | null
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          user_id: string
          batch_id: string
          local_image_id: string
          ai_title?: string | null
          ai_description?: string | null
          ai_keywords?: string[] | null
          ai_category?: string | null
          ai_emotions?: string[] | null
          ai_colors?: string[] | null
          ai_objects?: string[] | null
          custom_metadata?: any | null
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          user_id?: string
          batch_id?: string
          local_image_id?: string
          ai_title?: string | null
          ai_description?: string | null
          ai_keywords?: string[] | null
          ai_category?: string | null
          ai_emotions?: string[] | null
          ai_colors?: string[] | null
          ai_objects?: string[] | null
          custom_metadata?: any | null
          created_at?: string
          updated_at?: string
        }
      }
    }
    Views: {
      [_ in never]: never
    }
    Functions: {
      [_ in never]: never
    }
    Enums: {
      [_ in never]: never
    }
  }
}